export default {
    data(){
        return {
            playing: false
        }
    },
    methods: {
        start(){
            let self = this;
            this.playing = true;
            window.speechSynthesis.cancel();
            let parts = $(".component-wrapper-html_block").text().split(/\.|,|:|!/);
                for(let i in parts){
                    this.playing = true;
                    let utter = new SpeechSynthesisUtterance();

                    if(parts[i] === parts[parts.length -1]){
                        utter.onend = function(){
                            self.cancel();
                        };
                    }

                    if(parts[i] == ""){
                        break;
                    }

                    utter.lang = Lang._locale;
                    utter.text = parts[i];
                    utter.volume = 1;
                    utter.addEventListener("start", function(event){
                        console.log(event.utterance.text);
                    });
                    window.speechSynthesis.speak(utter);
                }
        },
        cancel(){
            window.speechSynthesis.cancel();
            this.playing = false;
        }
    }
}
